import { defineMessages } from 'react-intl';

const messages = defineMessages({
  petRentChargeWarning: {
    id: 'App.EditResidentHousehold.Pets.petRentChargeWarning',

    defaultMessage:
      // eslint-disable-next-line max-len
      'When you add or remove pets, monthly lease charges are automatically adjusted based on the pet details entered. Pet rent charges are created using the Pet Rent amount on the lease and will not be created automatically if the amount is blank or $0.00. Service animals are exempt from all pet-related charges.',
  },
  closeWithUnsavedChanges: {
    id: 'App.EditResidentHousehold.closeWithUnsavedChanges',
    defaultMessage: 'Are you sure you want to close without saving changes?',
  },
  confirmSave: {
    id: 'App.EditResidentHousehold.confirmSave',
    defaultMessage: 'Are you sure you want to save?',
  },
});

export default messages;
